import { type PossibleTheme } from '@/hooks/useTheme';

import { ACCOUNTS_ENV, ACCOUNTS_PARTNER_ID } from '../env';
import { AvailableSearchParams, getSearchParam } from './params';

declare global {
  interface Window {
    Eduzz: { Accounts: any };
  }
}

const accountsLoader = loadAccounts();

export async function getAccountsToken() {
  await accountsLoader;

  return await new Promise<string>((resolve, reject) => {
    if (!ACCOUNTS_PARTNER_ID) {
      throw new Error('no accounts env');
    }

    const themeParam = getSearchParam(AvailableSearchParams.THEME) as PossibleTheme;
    const dark = themeParam === 'dark';

    if (window) {
      window.Eduzz.Accounts.login(ACCOUNTS_PARTNER_ID, { env: ACCOUNTS_ENV, dark }).subscribe({
        next: (result: string) => {
          resolve(result);
          cleanUrl();
        },
        error: (err: any) => reject(err)
      });
    }
  });
}

async function loadAccounts() {
  try {
    if (!window) {
      return;
    }

    if (window.Eduzz?.Accounts) {
      return;
    }

    if (!(window as any).__verticalLoadingAccounts) {
      (window as any).__verticalLoadingAccounts = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.eduzzcdn.com/accounts/accounts.js';
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = err => reject(err);

        document.head.appendChild(script);
      });
    }

    return (window as any).__verticalLoadingAccounts;
  } catch (err) {
    console.error(err);
  }
}

function cleanUrl() {
  const params = new URLSearchParams(new URL(window.location.href).search.slice(1));
  params.delete('accounts_token');
  params.delete('accounts_login_token');

  const newParams = params.toString() ? `?${params.toString()}` : '';
  window.history.pushState(null, '', `${window.location.origin}${window.location.pathname}${newParams}`);
}

export function logout() {
  if (window) {
    window.Eduzz.Accounts.logout({ env: ACCOUNTS_ENV });
  }
}
